import { Injectable, inject, Signal } from '@angular/core';
import {
  PupilContext,
  Task,
  EventMovedInterface,
  HighlightedDate,
} from '@lyceo/shared/plan/util-models';
import { Store } from '@ngrx/store';
import { PlanModuleActions, PlanPageActions } from './plan.actions';
import * as PlanSelectors from './plan.selectors';

@Injectable({
  providedIn: 'root',
})
export class PlanFacade {
  private readonly store: Store = inject(Store);

  public activeDate: Signal<Date> = this.store.selectSignal(
    PlanSelectors.selectActiveDate,
  );
  public selectedDate: Signal<Date> = this.store.selectSignal(
    PlanSelectors.selectSelectedDate,
  );
  public numberOfWeeks: Signal<number> = this.store.selectSignal(
    PlanSelectors.selectNumberOfWeeks,
  );
  public pupilId: Signal<string | undefined> = this.store.selectSignal(
    PlanSelectors.selectPupilId,
  );
  public hasPupilContext: Signal<boolean> = this.store.selectSignal(
    PlanSelectors.selectHasPupilContext,
  );
  public highlightedDates: Signal<HighlightedDate[]> = this.store.selectSignal(
    PlanSelectors.selectHighlightedDates,
  );

  public activeDateChanged(date: Date): void {
    this.store.dispatch(PlanPageActions.activeDateChanged({ date }));
  }

  public calendarDayClicked(date: Date): void {
    this.store.dispatch(PlanPageActions.calendarDayClicked({ date }));
  }

  public calendarTaskClicked(date: Date, task: Task): void {
    this.store.dispatch(PlanPageActions.calendarTaskClicked({ date, task }));
  }

  public numberOfWeeksClicked(numberOfWeeks: number): void {
    this.store.dispatch(
      PlanPageActions.numberOfWeeksClicked({ numberOfWeeks }),
    );
  }

  public createNewTaskClicked(): void {
    this.store.dispatch(PlanPageActions.createNewTaskClicked());
  }

  public dayListTaskClicked(task: Task): void {
    this.store.dispatch(PlanPageActions.dayListTaskClicked({ task }));
  }

  public instructorCompleteTaskClicked(task: Task, value: boolean): void {
    this.store.dispatch(
      PlanPageActions.instructorCompleteTaskClicked({ task, value }),
    );
  }

  public pupilCompleteTaskClicked(
    task: Task,
    value: boolean,
    showReflection: boolean,
  ): void {
    this.store.dispatch(
      PlanPageActions.pupilCompleteTaskClicked({ task, value, showReflection }),
    );
  }

  public todoTaskClicked(task: Task): void {
    this.store.dispatch(PlanPageActions.todoTaskClicked({ task }));
  }

  public init(): void {
    this.store.dispatch(PlanPageActions.init());
  }

  public enter(): void {
    this.store.dispatch(PlanPageActions.enter());
  }

  public todayButtonClicked(): void {
    this.store.dispatch(PlanPageActions.todayButtonClicked());
  }

  public taskMoved(moved: EventMovedInterface): void {
    this.store.dispatch(PlanPageActions.taskMoved({ moved }));
  }

  public syncEloClicked(): void {
    this.store.dispatch(PlanPageActions.syncEloClicked());
  }

  public pupilContextChanged(pupilContext: PupilContext | undefined): void {
    this.store.dispatch(
      PlanModuleActions.pupilContextChanged({ pupilContext }),
    );
  }
}
